import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { ApplicationLocale } from '../models/locale';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  private _currentLocale: ApplicationLocale;

  constructor(@Inject(LOCALE_ID) public locale: string) {
    this._setCurrentLanguage();
  }

  private _setCurrentLanguage() {
    switch(this.locale) {
      case 'ar':
        this._currentLocale = ApplicationLocale.AR;
        return;
      case 'tr':
        this._currentLocale = ApplicationLocale.TR;
        return;
      default:
        this._currentLocale = ApplicationLocale.EN;
    }
  }

  get currentLocale() {
    return this._currentLocale;
  }

  isArabic() {
    return this._currentLocale === ApplicationLocale.AR;
  }

  isEnglish() {
    return this._currentLocale === ApplicationLocale.EN;
  }

  isTurkish() {
    return this._currentLocale === ApplicationLocale.TR;
  }
}
